module.exports = __webpack_public_path__ + "assets/img/5b1fffed9e0be1c9bfab6d1c77d3b521.png";